<template>
  <div class="d-flex justify-center">
    <settings-card/>
  </div>
</template>

<script>
import SettingsCard from '@/components/app/SettingsCard'

export default {
  components: {
    SettingsCard
  },
  name: "Settings"
}
</script>

<style scoped>

</style>